import { useSipPhoneContext } from '../SipPhoneContext';

export function useSipPhone() {
  return useSipPhoneContext();
}
